// SR-CUSTOM: Door Visualiser for the Design your own page (sections/design-your-own.liquid, setting door_visualiser).
// A pill on the photo opens a pop-out with Laminate and Timber tabs. Picking a door redraws the current photo on that door,
// in the browser, from the visualiser layers on Shopify Files (vis-manifest.json): the product cut-out for the photo, the
// scene's wall light-and-shadow map and bounce map, and the timber panel textures.
// The maths matches ~/Desktop/Sloan Roberts Content/4 Working files/Website & visualiser/wall-tone/vis/preview.py (light 1.0 since 19 Oct: the brightest part of the door shows the
// swatch colour, so whites read white; was 0.75, laminate surface = softened wall shading, 8% bounce on
// timber and marble bodies, no tint on metal, timber grain at true scale with the door's tilt and perspective).
// On phones and tablets (under 990px) the pop-out closes by itself when the page is scrolled down.
// The choice is remembered (localStorage "sr-door"). Tracking: dyo_door_open and dyo_door, like the builder's events.
// The rendering engine is also exposed as window.SRDoorEngine for the product pages (assets/sr-door-pdp.js, 19 Oct).
(function () {
  // Laminate colours (29 Oct 2026, David): FlipLab's best-selling flat-door colours (eight; Kalamata removed 29 Oct), plus their recommended timber.
  // Shown only as "Close match to <name>" (never with the maker's brand name). Values: the average colour of each swatch as
  // shown on fliplab.com, averaged (in Lab) with David's photo of the real samples on white paper (IMG_1331, 29 Oct,
  // paper-calibrated), then 15% less colour (David: "dull them back a little"). Approximate.
  // 29 Oct (David): French Cream and Paper Bark looked too green, so both were set neutral (Lab a* 1.0 / 0.0); Kalamata removed.
  // Then Paper Bark looked too grey: now a warm sandy greige, Lab 77 / 0.5 / 10.5.
  // Then (David: "check against the Laminex website"): each colour's HUE set to the maker's own swatch image (identical files on
  // laminex.com.au and fliplab.com), keeping our duller lightness and chroma; Outback Clay lightened to L67; Paper Bark hue 95
  // (maker 102 reads green to David).
  // The 4th field marks a close-match colour. Order: light to dark. Default door: see DEFAULT_DOOR below (picked automatically
  // the first time the visualiser is opened).
  // 29 Oct (later, David): the earlier colours with no near match in the FlipLab set are back (Warm White, Oyster, Taupe,
  // Blush, Tan, Clay, Olive; our own generic names and 19 Oct values, same ids so saved choices still work). Grouped:
  // whites and neutrals, warm, cool, then the earthy darks. Warm White is the default door again (about half of Australian
  // kitchens are white).
  var LAMINATES = [
    ['white', 'Warm White', '#F1F0EC'], ['french-cream', 'French Cream', '#EBE0CC', 1], ['oyster', 'Oyster', '#D6D3CC'],
    ['paper-bark', 'Paper Bark', '#C4BEAB', 1], ['taupe', 'Taupe', '#B4A79A'], ['blush', 'Blush', '#D7BAA9'],
    ['pale-honey', 'Pale Honey', '#D4B37F', 1], ['outback-clay', 'Outback Clay', '#BD9D83', 1],
    ['macedon-mist', 'Macedon Mist', '#A8AFB6', 1], ['spinifex', 'Spinifex', '#A2AFAA', 1], ['just-blue', 'Just Blue', '#9DB9CF', 1],
    ['olive', 'Olive', '#777E6C'], ['tan', 'Tan', '#9D8068'], ['clay', 'Clay', '#A47458'], ['moroccan-clay', 'Moroccan Clay', '#874B17', 1]
  ];
  var DEFAULT_DOOR = 'lam-white';
  // Timber doors, light to dark: our seven stain panels, plus Florentine Walnut (FlipLab's recommended woodgrain, 29 Oct:
  // our oak texture toned to the swatch's average colour, panel vis-panel-florentine-walnut-*.jpg on Files)
  // 29 Oct (David): our Walnut panel removed; Florentine Walnut takes its place (the two were almost the same colour)
  // 29 Oct (David): Charcoal removed too
  var TIMBERS = ['whitewash', 'natural-oak', 'smoked-grey', 'florentine-walnut', 'espresso', 'ebonised'];
  var TIMBER_HEX = { 'natural-oak': '#D2B493', 'walnut': '#8A6650', 'florentine-walnut': '#87664F', 'whitewash': '#D9D1C3', 'smoked-grey': '#97938B', 'espresso': '#5E4B3F', 'charcoal': '#433A35', 'ebonised': '#31302F' };
  var MATCHES = { 'florentine-walnut': 1 };   // timber panels shown as "Close match to …"
  // Words for a door. Close-match colours: chip "Close match to Paper Bark", caption "Close match to Paper Bark · …",
  // and "Paper Bark (close match) laminate door" in sentences (alt text, shortlist "Seen on …").
  function doorWords(o) { return o.name + (o.match ? ' (close match)' : '') + (o.kind === 'timber' ? ' timber' : ' laminate'); }
  function chipLabel(o) { return o.match ? 'Close match to ' + o.name : o.name; }
  function capWords(o) { return (o.match ? 'Close match to ' + o.name : doorWords(o) + ' door') + ' · colours are a guide only'; }
  function options() {
    var O = {};
    LAMINATES.forEach(function (l) { O['lam-' + l[0]] = { id: 'lam-' + l[0], kind: 'laminate', name: l[1], hex: l[2], match: !!l[3] }; });
    TIMBERS.forEach(function (t) { O[t] = { id: t, kind: 'timber', name: t.split('-').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' '), hex: TIMBER_HEX[t] || '#B89A78', match: !!MATCHES[t] }; });
    return O;
  }
  var LIGHT = 1.0, BOUNCE = 0.08, PERSP_Q = -0.15, LUM_R = 0.2126, LUM_G = 0.7152, LUM_B = 0.0722;
  var N_VIEW = 1024;

  // sRGB <-> linear lookups
  var LIN = new Float32Array(256);
  for (var i = 0; i < 256; i++) { var c = i / 255; LIN[i] = c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); }
  var OUT = new Uint8ClampedArray(4096);
  for (i = 0; i < 4096; i++) { var l = i / 4095; OUT[i] = Math.round(255 * (l <= 0.0031308 ? l * 12.92 : 1.055 * Math.pow(l, 1 / 2.4) - 0.055)); }
  function toByte(v) { return OUT[v <= 0 ? 0 : v >= 1 ? 4095 : (v * 4095 + 0.5) | 0]; }
  function hexLin(h) { var n = parseInt(h.slice(1), 16); return [LIN[(n >> 16) & 255], LIN[(n >> 8) & 255], LIN[n & 255]]; }
  function shoulder(x) { return x < 0.85 ? x : 0.85 + 0.15 * Math.tanh((x - 0.85) / 0.15); }
  // "an Ebonised door", "a Sage door"
  function article(w) { return /^[aeiou]/i.test(String(w)) ? 'an' : 'a'; }

  // Manifest key of a photo URL: basename without query/extension, Shopify _<uuid> and _800x suffixes and trailing -WEB,
  // lowercased, letters and digits only (same rule as vis-manifest.json keyRule)
  function photoKey(url) {
    var b = String(url || '').split('?')[0].split('/').pop().replace(/\.[a-z0-9]+$/i, '');
    b = b.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '').replace(/_\d+x\d*$/i, '').replace(/-WEB$/i, '');
    return b.toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function loadPixels(url, n) {
    return new Promise(function (ok, fail) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = function () {
        try {
          var w = n || im.naturalWidth, h = n || im.naturalHeight;
          var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
          var cx = cv.getContext('2d', { willReadFrequently: true });
          cx.imageSmoothingQuality = 'high';
          cx.drawImage(im, 0, 0, w, h);
          ok({ w: w, h: h, d: cx.getImageData(0, 0, w, h).data });
        } catch (e) { fail(e); }
      };
      im.onerror = function () { fail(new Error('image ' + url)); };
      im.src = url;
    });
  }

  // Separable box blur (odd size k), applied in place
  function boxBlur(a, n, k) {
    if (k < 2) return a;
    var r = k >> 1, tmp = new Float32Array(a.length), x, y, s, row;
    for (y = 0; y < n; y++) {
      row = y * n; s = 0;
      for (x = -r; x <= r; x++) s += a[row + Math.min(n - 1, Math.max(0, x))];
      for (x = 0; x < n; x++) {
        tmp[row + x] = s / k;
        s += a[row + Math.min(n - 1, x + r + 1)] - a[row + Math.max(0, x - r)];
      }
    }
    for (x = 0; x < n; x++) {
      s = 0;
      for (y = -r; y <= r; y++) s += tmp[Math.min(n - 1, Math.max(0, y)) * n + x];
      for (y = 0; y < n; y++) {
        a[y * n + x] = s / k;
        s += tmp[Math.min(n - 1, y + r + 1) * n + x] - tmp[Math.max(0, y - r) * n + x];
      }
    }
    return a;
  }

  // ---- Rendering engine, shared by this page and the Ensemble product pages (assets/sr-door-pdp.js reaches it through
  // window.SRDoorEngine). One manifest per page: the first init() wins.
  var manifestUrl = '';
  // ---- manifest and cached pixel data
  var manifestP = null, M = null;
  function manifest() {
    if (!manifestP) manifestP = fetch(manifestUrl, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error('manifest'); return r.json(); }).then(function (j) { M = j; return j; });
    return manifestP;
  }
  function fileUrl(name, w) { return M.base + name + '?v=' + encodeURIComponent((M.revOverride && M.revOverride[name]) || M.rev) + (w ? '&width=' + w : ''); }
  // Timber swatches (chips and the small door dot), 19 Oct 2026: the middle 28mm of the 140mm "close" panel texture, cut by
  // Shopify's image CDN (crop=region), so the grain reads at chip size. The whole texture shrunk to a 30px chip looked flat.
  function swatchUrl(id, w) {
    var p = M && M.textures.panels[id];
    if (!p) return '';
    var px = (M.settings && M.settings.texPx) || 1400, c = Math.round(px * 0.2), at = Math.round((px - c) / 2);
    return fileUrl(p.close) + '&crop=region&crop_left=' + at + '&crop_top=' + at + '&crop_width=' + c + '&crop_height=' + c + (w ? '&width=' + w : '');
  }
  var cache = {};
  function cached(key, make) { if (!cache[key]) cache[key] = make().catch(function (e) { delete cache[key]; throw e; }); return cache[key]; }

  function sceneData(sceneId, n) {
    return cached('scene|' + sceneId + '|' + n, function () {
      var sc = M.scenes[sceneId];
      return Promise.all([loadPixels(fileUrl(sc.wall, n), n), loadPixels(fileUrl(sc.bounce, n), n)]).then(function (r) {
        var wall = r[0].d, bnc = r[1].d, cnt = n * n, S = new Float32Array(cnt), bw = new Float32Array(cnt);
        for (var i = 0, j = 0; i < cnt; i++, j += 4) {
          S[i] = (LUM_R * LIN[wall[j]] + LUM_G * LIN[wall[j + 1]] + LUM_B * LIN[wall[j + 2]]) / sc.yref;
          bw[i] = bnc[j] / 255;
        }
        // Laminate and timber doors use the softened wall shading (5x5 box twice at 2048px)
        var k = Math.max(1, Math.round(5 * n / 2048)) | 1;
        boxBlur(boxBlur(S, n, k), n, k);
        return { sc: sc, wall: wall, S: S, bw: bw, n: n };
      });
    });
  }
  function layerData(stem, n) { return cached('layer|' + stem + '|' + n, function () { return loadPixels(fileUrl('vis-' + stem + '.webp', n), n); }); }
  function panelTile(id, sc, n) {
    var s = sc.ppm * (n / sc.px) * sc.boost * (M.settings.texMM[sc.crop] || 272) / (M.settings.texPx || 1400);
    var tw = Math.max(16, Math.round((M.settings.texPx || 1400) * s));
    return cached('panel|' + id + '|' + sc.crop + '|' + tw, function () {
      var name = M.textures.panels[id][sc.crop];
      return loadPixels(fileUrl(name, tw), tw);
    });
  }

  // ---- render one design on one door at n x n pixels; resolves to a blob URL
  function render(entry, opt, n) {
    var stem = entry[0], sceneId = entry[1];
    return manifest().then(function () {
      return sceneData(sceneId, n).then(function (S) {
        var jobs = [S, layerData(stem, n)];
        if (opt.kind === 'timber') jobs.push(panelTile(opt.id, S.sc, n));
        return Promise.all(jobs);
      });
    }).then(function (r) {
      var sd = r[0], L = r[1].d, tile = r[2], sc = sd.sc, cnt = n * n;
      var p, T = null;
      if (opt.kind === 'timber') {
        p = M.textures.panels[opt.id].mean_lin;
        T = timberField(tile, sc, n);
      } else p = hexLin(opt.hex);
      var yp = Math.max(LUM_R * p[0] + LUM_G * p[1] + LUM_B * p[2], 1e-4);
      var cpr = Math.min(2.5, Math.max(0.4, p[0] / yp)), cpg = Math.min(2.5, Math.max(0.4, p[1] / yp)), cpb = Math.min(2.5, Math.max(0.4, p[2] / yp));
      var lr = Math.max(yp * LIGHT / sc.yref, 0.02), lnLr = Math.log(lr);
      var bnc = /^Metal-/.test(stem) ? 0 : BOUNCE;
      var out = new ImageData(n, n), o = out.data, wall = sd.wall, Sv = sd.S, bw = sd.bw;
      for (var i = 0, j = 0; i < cnt; i++, j += 4) {
        var s = Sv[i] * LIGHT, Wr, Wg, Wb;
        if (T) { Wr = shoulder(s * T[i * 3]); Wg = shoulder(s * T[i * 3 + 1]); Wb = shoulder(s * T[i * 3 + 2]); }
        else { Wr = shoulder(s * p[0]); Wg = shoulder(s * p[1]); Wb = shoulder(s * p[2]); }
        var a = L[j + 3] / 255, rr, gg, bb;
        if (a <= 0) { rr = Wr; gg = Wg; bb = Wb; }
        else {
          var Dr = LIN[L[j]] * a, Dg = LIN[L[j + 1]] * a, Db = LIN[L[j + 2]] * a, fr = 1, fg = 1, fb = 1;
          var rk = bnc * bw[i];
          if (rk > 0) {
            var Br = LIN[wall[j]], Bg = LIN[wall[j + 1]], Bb = LIN[wall[j + 2]];
            var inv = 1 / Math.max(LUM_R * Br + LUM_G * Bg + LUM_B * Bb, 1e-4), pw = Math.exp(lnLr * rk * 0.35);
            fr = (1 + rk * (cpr / Math.max(Br * inv, 1e-3) - 1)) * pw;
            fg = (1 + rk * (cpg / Math.max(Bg * inv, 1e-3) - 1)) * pw;
            fb = (1 + rk * (cpb / Math.max(Bb * inv, 1e-3) - 1)) * pw;
          }
          rr = Dr * fr + (1 - a) * Wr; gg = Dg * fg + (1 - a) * Wg; bb = Db * fb + (1 - a) * Wb;
        }
        o[j] = toByte(rr); o[j + 1] = toByte(gg); o[j + 2] = toByte(bb); o[j + 3] = 255;
      }
      var cv = document.createElement('canvas'); cv.width = n; cv.height = n;
      cv.getContext('2d').putImageData(out, 0, 0);
      return new Promise(function (ok, fail) {
        cv.toBlob(function (b) { b ? ok(URL.createObjectURL(b)) : fail(new Error('blob')); }, 'image/jpeg', 0.9);
      });
    });
  }

  // Timber door texture in linear light, at the scene's real scale: mirror-tiled, the door tilt (vertical shear) and
  // perspective (grain larger on the left), softened slightly towards the right like the photos' depth of field
  function timberField(tile, sc, n) {
    var tw = tile.w, th = tile.h, d = tile.d, T = new Float32Array(n * n * 3);
    var c = n / 2, k = Math.tan((sc.grain_angle || 0) * Math.PI / 180), tw2 = 2 * tw, th2 = 2 * th;
    function wx(q) { q = ((q % tw2) + tw2) % tw2; return q >= tw ? tw2 - 1 - q : q; }
    function wy(q) { q = ((q % th2) + th2) % th2; return q >= th ? th2 - 1 - q : q; }
    for (var y = 0; y < n; y++) {
      for (var x = 0; x < n; x++) {
        var xn = (x - c) / n, yt = y - k * (x - c), w = 1 + PERSP_Q * xn;
        var qx = (xn / w) * n + tw / 2, qy = (((yt - c) / n) / w) * n + th / 2;
        var x0 = Math.floor(qx), y0 = Math.floor(qy), fx = qx - x0, fy = qy - y0;
        var a0 = wx(x0), a1 = wx(x0 + 1), b0 = wy(y0) * tw, b1 = wy(y0 + 1) * tw;
        var i00 = (b0 + a0) * 4, i10 = (b0 + a1) * 4, i01 = (b1 + a0) * 4, i11 = (b1 + a1) * 4, t = (y * n + x) * 3;
        for (var ch = 0; ch < 3; ch++) {
          T[t + ch] = (LIN[d[i00 + ch]] * (1 - fx) + LIN[d[i10 + ch]] * fx) * (1 - fy) + (LIN[d[i01 + ch]] * (1 - fx) + LIN[d[i11 + ch]] * fx) * fy;
        }
      }
    }
    // Right-side softening: sigma 1.2px at 2048, blended in from just left of centre to the right edge
    var passes = Math.round(Math.pow(1.2 * n / 2048, 2) / 0.5);
    if (passes > 0) {
      var B = new Float32Array(T), tmp = new Float32Array(T.length), p, yy, xx, cc, idx;
      for (p = 0; p < passes; p++) {
        for (yy = 0; yy < n; yy++) for (xx = 0; xx < n; xx++) for (cc = 0; cc < 3; cc++) {
          idx = (yy * n + xx) * 3 + cc;
          tmp[idx] = 0.25 * B[(yy * n + Math.max(0, xx - 1)) * 3 + cc] + 0.5 * B[idx] + 0.25 * B[(yy * n + Math.min(n - 1, xx + 1)) * 3 + cc];
        }
        for (yy = 0; yy < n; yy++) for (xx = 0; xx < n; xx++) for (cc = 0; cc < 3; cc++) {
          idx = (yy * n + xx) * 3 + cc;
          B[idx] = 0.25 * tmp[(Math.max(0, yy - 1) * n + xx) * 3 + cc] + 0.5 * tmp[idx] + 0.25 * tmp[(Math.min(n - 1, yy + 1) * n + xx) * 3 + cc];
        }
      }
      for (yy = 0; yy < n; yy++) for (xx = 0; xx < n; xx++) {
        var wt = Math.min(1, Math.max(0, ((xx - c) / n + 0.1) / 0.6));
        if (!wt) continue;
        for (cc = 0; cc < 3; cc++) { idx = (yy * n + xx) * 3 + cc; T[idx] = T[idx] * (1 - wt) + B[idx] * wt; }
      }
    }
    return T;
  }

  window.SRDoorEngine = {
    laminates: LAMINATES, timbers: TIMBERS, timberHex: TIMBER_HEX, defaultDoor: DEFAULT_DOOR, photoKey: photoKey, article: article,
    options: options, doorWords: doorWords, chipLabel: chipLabel, capWords: capWords,
    init: function (url) { if (!manifestUrl && url) manifestUrl = url; },
    manifest: manifest, data: function () { return M; }, fileUrl: fileUrl, swatchUrl: swatchUrl, render: render
  };

  document.querySelectorAll('[data-dyo]').forEach(function (root) {
    var data;
    try { data = JSON.parse(root.querySelector('[data-dyo-data]').textContent); } catch (e) { return; }
    var cfg = data.door || {};
    var pill = root.querySelector('[data-door-toggle]'), pop = root.querySelector('[data-door-pop]');
    if (!cfg.on || !cfg.manifest || !pill || !pop) return;
    window.SRDoorEngine.init(cfg.manifest);
    var photo = root.querySelector('[data-photo]'), over = root.querySelector('[data-door-img]');
    var chipsBox = pop.querySelector('[data-door-chips]'), cap = pop.querySelector('[data-door-cap]');
    var label = pill.querySelector('[data-door-label]'), dot = pill.querySelector('[data-door-dot]');
    var $ = function (s) { return root.querySelector(s); };

    var OPTIONS = options();

    var door = null, tab = 'laminate', isOpen = false;
    try { var sv = JSON.parse(localStorage.getItem('sr-door') || 'null'); if (sv && OPTIONS[sv]) door = OPTIONS[sv]; } catch (e) {}
    if (door) tab = door.kind;

    // Tracking, same channels as the builder (assets/design-your-own.js)
    function track(name, extra) {
      var q = new URLSearchParams(location.search), p = { material: q.get('material') || '', size: q.get('size') || '', button: q.get('button') || '' };
      p.design = p.material + '_' + p.size + '_' + p.button;
      Object.keys(extra || {}).forEach(function (k) { p[k] = extra[k]; });
      var meta = { door_open: 'DYODoorOpen', door: 'DYODoor' };
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('dyo_' + name, p); } catch (e) {}
      try { if (typeof window.gtag === 'function') window.gtag('event', 'dyo_' + name, p); } catch (e) {}
      try { if (typeof window.fbq === 'function') window.fbq('trackCustom', meta[name], p); } catch (e) {}
    }

    // ---- UI
    function chipsHtml() {
      var html = '';
      Object.keys(OPTIONS).forEach(function (id) {
        var o = OPTIONS[id];
        if (o.kind !== tab) return;
        var bg = o.kind === 'timber' && M && M.textures.panels[o.id] ? 'background-image:url(' + swatchUrl(o.id, 120) + ');background-color:' + o.hex : 'background-color:' + o.hex;
        html += '<button type="button" class="dyo-door-chip" data-door-pick="' + o.id + '" aria-label="' + chipLabel(o) + '" aria-pressed="' + (!!door && door.id === o.id) + '" title="' + chipLabel(o) + '" style="' + bg + '"></button>';
      });
      return html;
    }
    function renderChips() {
      chipsBox.innerHTML = chipsHtml();
      pop.querySelectorAll('[data-door-tab]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-door-tab') === tab)); });
    }
    function setCaption(t) { cap.textContent = t; }
    function renderPill() {
      label.textContent = door ? 'Door: ' + door.name : 'Door Visualiser';
      pill.classList.toggle('has-door', !!door);
      dot.style.backgroundColor = door ? door.hex : 'transparent';
      dot.style.backgroundImage = door && door.kind === 'timber' && M && M.textures.panels[door.id] ? 'url(' + swatchUrl(door.id, 64) + ')' : 'none';
      pill.setAttribute('aria-label', door ? 'Door Visualiser, showing ' + article(door.name) + ' ' + doorWords(door) + ' door' : 'Door Visualiser');
    }

    // The small pictures in the pop-ups (other sizes in the added-to-cart pop-up, the spec card) are drawn on the chosen
    // door too, at 128px (David, 19 Oct). Each keeps its product photo URL in data-door-orig, so "Original photo" puts it back.
    var N_THUMB = 128, thumbUrls = {};
    function thumbFor(src, d) {
      var key = photoKey(src), k = key + '|' + d.id;
      if (!thumbUrls[k]) thumbUrls[k] = manifest().then(function () {
        var entry = M.images[key];
        if (!entry) throw new Error('nolayer');
        return render(entry, d, N_THUMB);
      }).catch(function (e) { delete thumbUrls[k]; throw e; });
      return thumbUrls[k];
    }
    function doorThumbs() {
      var d = door;
      root.querySelectorAll('[data-quick] img, [data-spec-img]').forEach(function (img) {
        var cur = img.getAttribute('src') || '', orig = img.getAttribute('data-door-orig');
        if (cur && cur.indexOf('blob:') !== 0 && cur !== orig) { orig = cur; img.setAttribute('data-door-orig', orig); }
        if (!orig) return;
        if (!d) { if (cur !== orig) img.src = orig; return; }
        thumbFor(orig, d).then(function (url) {
          if (door === d && img.getAttribute('data-door-orig') === orig && img.getAttribute('src') !== url) img.src = url;
        }).catch(function () {});
      });
    }

    var token = 0, currentUrl = null, shownFor = '', pendingFor = '';
    function hideOverlay() { over.classList.remove('is-on'); shownFor = ''; pendingFor = ''; }
    function refresh() {
      var my = ++token;
      renderPill();
      doorThumbs();
      // The page's shortlist heart saves the door the design was seen on
      root.setAttribute('data-door', door ? door.id : '');
      root.setAttribute('data-door-name', door ? doorWords(door) : '');
      if (!door) { hideOverlay(); setCaption('Pick a door to see your design on it.'); return; }
      var src = photo.getAttribute('src') || '';
      var key = photoKey(src), want = key + '|' + door.id;
      if (shownFor === want || pendingFor === want) return;
      pendingFor = want;
      over.classList.remove('is-on');
      pill.classList.add('is-loading');
      setCaption('Loading your door…');
      manifest().then(function () {
        var entry = M.images[key];
        if (!entry) throw new Error('nolayer');
        return render(entry, door, N_VIEW);
      }).then(function (url) {
        if (my !== token) { URL.revokeObjectURL(url); return; }
        var old = currentUrl; currentUrl = url;
        over.onload = function () { if (my === token) over.classList.add('is-on'); if (old) URL.revokeObjectURL(old); };
        over.src = url;
        over.alt = (photo.alt || 'Your design') + ', shown on ' + article(door.name) + ' ' + doorWords(door) + ' door';
        shownFor = want; pendingFor = '';
        pill.classList.remove('is-loading');
        renderPill();
        setCaption(capWords(door));
      }).catch(function (e) {
        if (my !== token) return;
        pendingFor = '';
        pill.classList.remove('is-loading');
        hideOverlay();
        setCaption(e && e.message === 'nolayer' ? 'The door preview isn’t available for this design yet.' : 'The door preview didn’t load. Please try again.');
      });
    }

    // Opening or closing the pop-out changes the page height above the steps. When the visitor is already down in the
    // steps (phones: the photo and pop-out are stuck at the top), keep the steps where they were. Chrome does this itself
    // (scroll anchoring), so the measured shift is 0 there; Safari has no scroll anchoring and gets the correction.
    function scrollAnchor() { return $('.dyo-steps'); }
    var openY = 0, openAt = 0;
    function setOpen(v) {
      if (v === isOpen) return;
      var anchor = scrollAnchor(), box = $('.dyo-photo');
      var before = anchor ? anchor.getBoundingClientRect().top : 0;
      var keep = !!(anchor && box && window.innerWidth < 990 && before < box.getBoundingClientRect().bottom + 1);
      isOpen = v;
      pop.hidden = !v;
      pill.setAttribute('aria-expanded', String(v));
      if (keep) {
        var after = anchor.getBoundingClientRect().top;
        if (Math.abs(after - before) > 1) window.scrollBy(0, after - before);
      }
      if (v) {
        openY = window.scrollY; openAt = Date.now();
        if (!door) {
          door = OPTIONS[DEFAULT_DOOR]; tab = door.kind;
          try { localStorage.setItem('sr-door', JSON.stringify(door.id)); } catch (e) {}
          refresh();
        }
        manifest().then(function () { renderChips(); renderPill(); }).catch(function () {});
        renderChips();
        track('door_open');
      }
    }

    pill.addEventListener('click', function () { setOpen(!isOpen); });
    pop.addEventListener('click', function (e) {
      var t = e.target.closest('[data-door-tab],[data-door-pick],[data-door-close]');
      if (!t) return;
      if (t.hasAttribute('data-door-close')) { setOpen(false); pill.focus({ preventScroll: true }); return; }
      if (t.hasAttribute('data-door-tab')) { tab = t.getAttribute('data-door-tab'); renderChips(); return; }
      var id = t.getAttribute('data-door-pick');
      door = id ? OPTIONS[id] : null;
      try { localStorage.setItem('sr-door', JSON.stringify(door ? door.id : null)); } catch (err) {}
      renderChips();
      refresh();
      var again = chipsBox.querySelector('[data-door-pick="' + (id || '') + '"]'); if (again) again.focus({ preventScroll: true });
      track('door', { door: door ? door.id : 'original', door_kind: door ? door.kind : 'none' });
    });
    pop.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setOpen(false); pill.focus({ preventScroll: true }); } });

    // Phones and tablets: close the pop-out once the page is scrolled down (40px). Scroll changes in the first
    // moments after opening come from the page settling, not the visitor, so they only reset the starting point.
    window.addEventListener('scroll', function () {
      if (!isOpen || window.innerWidth >= 990) return;
      if (Date.now() - openAt < 300 || window.scrollY < openY) { openY = window.scrollY; return; }
      if (window.scrollY - openY > 40) setOpen(false);
    }, { passive: true });

    // New photo (material, button or size changed): redraw on the chosen door
    new MutationObserver(function () { if (door) refresh(); else hideOverlay(); }).observe(photo, { attributes: true, attributeFilter: ['src'] });
    // Pop-up pictures: the other-sizes rows are rebuilt on every change, the spec card picture gets a new src when it opens
    var quickBox = $('[data-quick]'), specImg = $('[data-spec-img]');
    if (quickBox) new MutationObserver(doorThumbs).observe(quickBox, { childList: true });
    if (specImg) new MutationObserver(doorThumbs).observe(specImg, { attributes: true, attributeFilter: ['src'] });

    // Enlarged photo: show the door version too (desktop redraws it at full size)
    var zoomBtn = $('[data-zoom]');
    if (zoomBtn) zoomBtn.addEventListener('click', function () {
      if (!door || !over.classList.contains('is-on') || !currentUrl) return;
      var big = $('[data-zoom-img]'), capEl = $('[data-zoom-cap]'), my = token, d = door;
      if (!big) return;
      big.src = currentUrl;
      if (capEl) capEl.textContent = capEl.textContent + ' · on ' + article(d.name) + ' ' + doorWords(d) + ' door';
      if (window.innerWidth < 990) return;
      var entry = M && M.images[photoKey(photo.getAttribute('src'))];
      if (!entry) return;
      render(entry, d, 2048).then(function (url) {
        if (my === token && !$('[data-zoommodal]').hidden) { big.onload = function () { setTimeout(function () { URL.revokeObjectURL(url); }, 1000); }; big.src = url; }
        else URL.revokeObjectURL(url);
      }).catch(function () {});
    });

    renderPill();
    if (door) refresh();
  });
})();
